// extracted by mini-css-extract-plugin
export default {"container":"home_container__l-+NK","table":"home_table__XsThM","year":"home_year__S0F2R"};